import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from "vue";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import { BuilderSliderSteps } from "@/enums/BuilderSliderSteps";
  import BuilderSelectionHouse from "../../BuilderSelectionHouse.vue";
  import { BuilderQuote } from "@/types/BuilderQuote";
  import { FacadeInterface } from "@/types/FacadeInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'HouseAndFloorplanImage',
  props: {
    houseInfo: {},
    quote: {},
    selectedFacade: {}
  },
  emits: ["showFloorplan", "updateSelectedFacade"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;

  const showFloorplan = ref(false);
  const showInterior = ref(false);
  const selectedImage = ref<string | null>(null);

  const onChangeImage = (type: string) => {
    if (type === BuilderSliderSteps.FLOORPLAN) {
      showFloorplan.value = true;
      showInterior.value = false;
    } else if (type === BuilderSliderSteps.MAIN_IMAGE) {
      showFloorplan.value = false;
      showInterior.value = false;
      selectedImage.value = null;
    }

    emits("showFloorplan");
  };

  const onUpdateSelectedFacade = (facade: FacadeInterface) => {
    emits("updateSelectedFacade", facade);
  };

  const onSelectSection = (section: string) => {
    showFloorplan.value = false;
    showInterior.value = true;

    switch (section) {
      case BuilderSliderSteps.KITCHEN:
        selectedImage.value = props.houseInfo?.kitchens[0].url || null;
        break;
      case BuilderSliderSteps.BATHROOM:
        selectedImage.value = props.houseInfo?.bathroom.options[0].url || null;
        break;
      case BuilderSliderSteps.LIVING:
        selectedImage.value = props.houseInfo?.loungeRoom.urls[0] || null;
        break;
    }
  };

  watch(
    () => props.houseInfo,
    () => {
      selectedImage.value = props.houseInfo?.mainImages[0] || null;
    }
  );

const __returned__ = { props, emits, showFloorplan, showInterior, selectedImage, onChangeImage, onUpdateSelectedFacade, onSelectSection, onMounted, ref, watch, get HouseDesignInterface() { return HouseDesignInterface }, get BuilderSliderSteps() { return BuilderSliderSteps }, BuilderSelectionHouse, get BuilderQuote() { return BuilderQuote }, get FacadeInterface() { return FacadeInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})